import { useState } from "react";
import ThriveCaseSelection from "../common/ThriveCaseSelection";
import { axiosInstance } from "../../utils/networking";

interface Props {
  currentCase: any;
  setOpen: any;
}

const MergeCase: React.FC<Props> = ({ currentCase, setOpen }) => {
  const [selectedCase, setSelectedCase] = useState<any>({ firmRecord: {} });
  const [checkedCases, setCheckedCases] = useState<any[]>([]);

  const handleMergeCase = () => {
    axiosInstance
      .post(`/cases/merge`, {
        keep_case: currentCase._id,
        delete_case: selectedCase._id,
      })
      .then((res) => {
        window.location.reload();
      });
  };
  return (
    <>
      <ThriveCaseSelection
        height={430}
        cases={[]}
        reloadCases={true}
        checkedCases={checkedCases}
        setCheckedCases={setCheckedCases}
        selectedCase={selectedCase}
        setSelectedCase={setSelectedCase}
        enableControl={true}
        enableSelection={true}
        enableMultiSelection={false}
        setOpen={setOpen}
        status_default="either"
        sortby_default="recent"
        period_default="all"
        title={"Select Merge Case"}
        handleNext={handleMergeCase}
      ></ThriveCaseSelection>
    </>
  );
};
export default MergeCase;
